import React from 'react';
import LOGO_IMAGE from '../../../assets/images/logo.svg';
// import CollapseLogo from '../../../assets/images/collapsed-logo.png';
import { Link } from 'react-router-dom';

const LogoComponent: React.FC<any> = () => {
  return (
    <div className="logo__wrapper">
      <Link to="/action?action=Start">
        <img
          src={LOGO_IMAGE}
          alt="LOGO"
          style={{ width: 'auto', height: '40px' }}
        />
      </Link>
      {/* {collapsed ? (
        <Link to="/">
          <img src={CollapseLogo} alt="LOGO" style={{ maxWidth: 60 }} />
        </Link>
      ) : (
        <Link to="/">
          <img src={LOGO_IMAGE} alt="LOGO" />
        </Link>
      )} */}
    </div>
  );
};

export default LogoComponent;
